<template>
  <BlockFieldset class="project-customer-tax-bank">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('taxNumber')"
          label-for="taxNumber"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.taxNumber"
            type="text"
            :placeholder="$t('taxNumber')"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('bank')"
          label-for="bank"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input v-model="project.customer.bank" type="text" :placeholder="$t('bank')" />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('iban')"
          label-for="iban"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input v-model="project.customer.iban" type="text" :placeholder="$t('iban')" />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('bic')"
          label-for="bic"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input v-model="project.customer.bic" type="text" :placeholder="$t('bic')" />
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('accountHolder')"
          label-for="accountHolder"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.customer.accountHolder"
            type="text"
            :placeholder="$t('accountHolder')"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <div v-if="hasSaveButton" class="text-right mt-2">
      <b-button variant="bg" :disabled="isSaving" @click="save">
        {{ $t('saveNamed', { name: $t('project_customer_tax_bank') }) }}
      </b-button>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions } from 'vuex';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { toProjectCustomerTaxBankInput } from './projectCustomerTaxBankInput';

/** Number of the unsaved project (ProjectEdit `_new`): its values go with `createProject`. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-customer-tax-bank (plan docs/work/_done/2026-10-project-block-customer-tax-bank):
 * tax and bank fields on `customer`, saved through its own mutation. On the unsaved project it
 * has no save button. Emits `dirty` and `saved`.
 */
export default {
  name: 'ProjectCustomerTaxBank',
  components: { BlockFieldset },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  computed: {
    blockInput() {
      return toProjectCustomerTaxBankInput(this.project);
    },
    hasSaveButton() {
      return !this.isBlockReadOnly && this.project.number !== NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['updateProjectCustomerTaxBank']),
    saveBlockInput(input) {
      return this.updateProjectCustomerTaxBank({ projectNumber: this.project.number, input });
    },
  },
};
</script>
